import * as React from 'react'
import { useState } from 'react'


const Context = React.createContext({})

export function CommonFiltersAlertsContextProvider({ children }) {

	const initialFilterState = {
		alerts: 'competition', alertName: null, alertType: null, alertSubtype: null, comparison: null, 
		isLoadingAlerts: true, ikey: null, maxRangeDate: null, alertsOccupancy: null
	}

	const [state, setState] = useState(initialFilterState)

	return <Context.Provider value={{ state, setState, initialFilterState }}>
		{children}
	</Context.Provider>
}

export default Context